import React, { useState } from "react";
import { Link } from "react-router-dom";
import Students from "./students/students";
import Section from "./section";
import Class from "./class";

const InstituteSpecific = () => {

    const [activeTab, setActiveTab] = useState("Students");

    const tabData = [
        {
            icon: <i className="fas fa-child" />,
            name: "Students",
            content: <Students />
        },
        {
            icon: <i className="fas fa-list" />,
            name: "Section",
            content: <Section />
        },
        {
            icon: <i className="fas fa-university" />,
            name: "Class",
            content: <Class />
        },
    ]
    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">Students</h3>
                            </div>
                            <div className="row d-flex align-items-center">
                                <div className="col-xl-12 col-lg-12 col-sm-12 col-md-12">
                                    <div className="coach-court-list">
                                        <ul className="nav">
                                            {tabData.map((tab, i) => (
                                                <li key={i}>
                                                    <Link to="#"
                                                        className={tab.name === activeTab ? 'active' : ''}
                                                        onClick={() => setActiveTab(tab.name)}>
                                                        {tab.icon}  {tab.name}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                                <div className="tab-content">
                                    {tabData
                                        .filter(tab => tab.name === activeTab)
                                        .map((tab, i) => (
                                            <div key={i}>{tab.content}</div>
                                        ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InstituteSpecific;